import { Clock } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function CampaignEndedNotice({ endDate }: { endDate?: string | null }) {
  const { t, i18n } = useTranslation();
  const deadline = endDate ? new Date(endDate) : null;
  const formattedDeadline = deadline && Number.isFinite(deadline.getTime())
    ? new Intl.DateTimeFormat(i18n?.language?.startsWith('en') ? 'en-US' : 'pt-BR', {
      dateStyle: 'short', timeStyle: 'short', timeZone: 'America/Sao_Paulo',
    }).format(deadline)
    : null;

  return (
    <section role="status" className="rounded-xl border border-amber-500/40 bg-amber-500/10 p-4 sm:p-5">
      <div className="flex items-start gap-3">
        <Clock aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-amber-500" />
        <div className="space-y-1">
          <h2 className="font-semibold">{t('campaign.ended.title')}</h2>
          {formattedDeadline && <p className="text-sm">{t('campaign.ended.deadline', { date: formattedDeadline })}</p>}
          <p className="text-sm text-muted-foreground">{t('campaign.ended.submissionsClosed')}</p>
          <p className="text-sm text-muted-foreground">{t('campaign.ended.quotaNote')}</p>
        </div>
      </div>
    </section>
  );
}
